const CART_CBCC_NUDGE_PREFIX = "ccnpx";

export const CART_CBCC_NUDGE_TEST_IDS = {
    NUDGE_CONTAINER: `${CART_CBCC_NUDGE_PREFIX}_nudge_container`,
    CARD_IMAGE: `${CART_CBCC_NUDGE_PREFIX}_card_image`,
    PRE_CLICK_HEADING: `${CART_CBCC_NUDGE_PREFIX}_pre_click_heading`,
    PRE_CLICK_CTA: `${CART_CBCC_NUDGE_PREFIX}_pre_click_cta`,
    POST_CLICK_TEXT: `${CART_CBCC_NUDGE_PREFIX}_post_click_text`,
    POST_CLICK_HEADING: `${CART_CBCC_NUDGE_PREFIX}_post_click_heading`,
    LOADER: `${CART_CBCC_NUDGE_PREFIX}_loader`,
};
